<!--
 * @version: V1.0.0
 * @Date: 2023-02-22 16:24:03
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-09 18:47:36
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\material\components\DISelect.vue
 * @Descripttion:
-->
<template>
  <el-dialog :append-to-body="true" title="选择产品" :visible="visible" width="60%"  @close="$emit('close')">
    <el-form ref="queryForm" inline class="search-form" label-width="80px">
      <el-form-item label="产品名称" prop="productName">
        <el-input v-model.trim="queryParams.productName" placeholder="产品名称" clearable style="width: 160px">
        </el-input>
      </el-form-item>
      <el-form-item label="规格型号" prop="productSpecification">
        <el-input v-model.trim="queryParams.productSpecification" placeholder="规格型号" clearable style="width: 160px">
        </el-input>
      </el-form-item>
      <el-form-item label="DI码" prop="diCode">
        <el-input v-model.trim="queryParams.diCode" placeholder="DI码" clearable style="width: 160px">
        </el-input>
      </el-form-item>

      <el-form-item label="描述" prop="description">
        <el-input v-model.trim="queryParams.description" placeholder="描述" clearable style="width: 160px">
        </el-input>
      </el-form-item>

      <el-form-item label="DI状态" prop="recordStatus">
        <el-select v-model="queryParams.recordStatus" placeholder="请选择" >
          <el-option v-for="dict in dictsObj.di_record_status"
                     :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="包装级别" prop="packLevel">
        <el-input v-model.trim="queryParams.packLevel" placeholder="包装级别" clearable style="width: 160px">
        </el-input>
      </el-form-item>


      <el-form-item>
        <el-button size="small"  type="primary" @click="handleSearch">搜索</el-button>
        <el-button size="small"  type="primary" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="table" height="400" :data="udiDataList" style="width: 100%; margin-top: 12px" border stripe>
      <el-table-column label="" width="45" prop="">
        <template slot-scope="scope">
          <el-radio v-model="radio" :label="scope.row.id" @change="handleSelect(scope.row)">
            {{ '' }}
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="DI码" width="150" />
      <el-table-column prop="productName" label="产品名称" show-overflow-tooltip />
      <el-table-column prop="productSpecification" label="规格型号" show-overflow-tooltip />
      <el-table-column prop="packLevel" label="包装层级" show-overflow-tooltip />
      <el-table-column prop="description" label="描述" show-overflow-tooltip />
      <el-table-column label="DI状态" show-overflow-tooltip width="100">
        <template slot-scope="{ row }">
          <dict-tag :options="dictsObj.di_record_status" :value="row.recordStatus"></dict-tag>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" style="margin-top: 24px" :total="total" :page-sizes="[50, 100, 300]"
      :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="handleOk"> 确 定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getFilterDIList } from '@/api/material'
import { getDict } from '@/api/common/index'

export default {
  name: 'DISelect',
  props: {
    loading: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data: () => {
    return {
      total: 0,
      selection: null,
      radio: null,
      udiDataList: [],
      dictsObj: {
        di_record_status: []
      },
      queryParams: {
        pageNum: 1,
        pageSize: 50,
        productSpecification: null,
        packLevel: null,
        description: null,
        recordStatus: null,
        diCode: null,
        productName: null
      },
    }
  },
  mounted() {
    this.getDict(['di_record_status'])
    this.getList()
  },
  methods: {
    getDict(list) {
      list.forEach((dictType) => {
        getDict({ dictType }).then((res) => {
          if (dictType === 'di_record_status') {
            const da = res.rows.filter(item => item.dictLabel !== '已报废' && item.dictLabel !== '草稿')
            this.dictsObj[dictType] = da
          }else {
            this.dictsObj[dictType] = res.rows
          }
        })
      })
    },
    handleOk() {
      if (!this.selection) {
        this.$message.error('请选择产品')
        return
      }
      this.$emit('getData', this.selection)
    },
    // 搜索按钮点击
    handleSearch() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /**
     * @description: 处理勾选
     * @return {*}
     */
    handleSelect(val) {
      this.selection = val
      this.radio = val.id
    },
    /**
     * @description: 重置筛选条件
     * @return {*}
     */
    reset() {
      this.queryParams = Object.assign(
        this.$data.queryParams,
        this.$options.data.call(this)
      ).queryParams
      this.getList()
    },
    // 获取列表数据
    getList() {
      // 获取生产任务列表数据
      this.$emit('update:loading', true) // 打开遮罩
      getFilterDIList({ ...this.queryParams })
        .then((res) => {
          this.udiDataList = res.data.rows
          this.total = res.data.total
        })
        .finally(() => {
          this.$emit('update:loading', false) // 关闭遮罩
        })
    }
  }
}
</script>
